import React from "react";

import { Divider } from "../index";

import styles from "./header.module.css";
import HeaderLogo from "./components/header-logo";
import LangSwitch from "./components/lang-switch";

const SimpleHeader = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.simpleLogoContainer}>
            <HeaderLogo />
          </div>
          <LangSwitch />
        </div>
      </div>
      <Divider />
    </>
  );
};

export default SimpleHeader;
